import React from 'react';
import { useParams } from 'react-router-dom';

import {
    useLang,
    useMediaConfigGame,
} from 'bdvp-common/src/hooks/config';
import { useBackToState } from 'bdvp-common/src/hooks';

import Row from 'bdvp-common/src/containers/CarouselRow';
import LazyLoad from 'bdvp-common/src/components/LazyLoad';

const defaultCarousels = [
    {
        title: {
            en: 'Offensive Highlights',
            es: 'Mejores Jugadas Ofensivas',
        },
        searchQuery: 'ContentTags == ["hitting","gamepk-{{gamePk}}"] Order By Timestamp DESC',
    },
    {
        title: {
            en: 'Defensive Highlights',
            es: 'Mejores Jugadas Defensivas',
        },
        searchQuery: 'ContentTags == ["defense","gamepk-{{gamePk}}"] Order By Timestamp DESC',
    },
    {
        title: {
            en: 'Pitching Highlights',
            es: 'Mejores Lanzamientos',
        },
        searchQuery: 'ContentTags == ["pitching","gamepk-{{gamePk}}"] Order By Timestamp DESC',
    },
    {
        title: {
            en: 'Postgame Highlights',
            es: 'Mejores Momentos Post Partido',
        },
        searchQuery: 'GamePk = {{gamePk}} AND ContentTags = ["interview","press-conference","manager-postgame"] Order By Timestamp DESC',
    },
];

const Carousels = () => {

    const { gamePk } = useParams();

    const lang = useLang();
    const config = useMediaConfigGame();
    const backToState = useBackToState('back_to_game_page');

    const carousels = config.carousels || defaultCarousels;

    const rows = carousels.map(({ title, searchQuery }) => ({
        title: title[lang],
        query: searchQuery.replace('{{gamePk}}', gamePk).replace(/'/g, '"'),
        onItemClickHistoryPushState: backToState,
    }));

    return (
        rows.map((row, index) => (
            <LazyLoad
                key={index}
                render={({
                    elementRef,
                    isVisible,
                }) => {

                    return (
                        <Row
                            ref={elementRef}
                            skip={!isVisible}
                            ssr={false}
                            properties={row}
                            rank={index}
                        />
                    );

                }}
            />
        ))
    );

};

export default React.memo(Carousels);
